
/** npm import */
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router';
// import ReactDatatable from '@ashvin27/react-datatable';
import ReactDatatable from "react-data-table-component";

/** local file import */
import Header from '../Layout/header'
import Subscriber from '../Layout/subscribe';
import Footer from '../Layout/footer';
import config from '../helper/config';
import { GetuserData, SupportTicketAction } from '../Axios/user.axios';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { DateTimeForm, FirstCaps, isEmpty } from '../helper/common';




/** code start */

const initform = {
    Subject: '',
    Message: '',
    Attachment: '',
}


const SupportTicket = () => {

    const [attachmentName, setAttachmentName] = useState("Click To Choose");

    const attachmentRef = useRef(null)

    const userdata = useSelector((state)=>state?.LoginReducer?.User)
    const navigate = useNavigate();

    const [ SupportTicketList, SetSupportTicketList ] = useState([])
    const [formdata, SetFormData] = useState(initform);
    const [Errors, SetErrors] = useState({});
    const [Disable, SetDisable ] = useState(false);
    const [DisableStatus, SetDiableStatus] = useState(false);


    const customStyles = {
        headRow: {
          style: {
            color:'#000',
            fontSize: "14px",
            // backgroundColor: '#e7eef0'
          },
        },
        striped: {
            default: 'red'
        },
      }

    const columns = [
        {
          id: 1,
          name: "Created Date",
        //   selector: (row) => row.createdAt,
        cell: rec => <div>{DateTimeForm(rec?.createdAt,true)}</div>,
        //   sortable: true,
          reorder: true,
          width: "200",
        },
        

        {
          id: 2,
          name: "Subject",
          selector: (row) => row?.Subject,
        //   sortable: true,
          reorder: true,
          width: "200",
        },
        {
            id: 3,
            name: "Ticket Status",
            selector: (row) => row.ticketStatus,
          //   sortable: true,
            right: true,
            reorder: true,
            width: "200",
          },

      ]
    
    // const columns = [

    //     {
    //         key: "createdAt",
    //         text: "Created Date",
    //         className: "w_150 text-center",
    //         align: "center",
    //         width: 150,
    //         sortable: true,
    //         cell: rec => <div>{DateTimeForm(rec?.createdAt,true)}</div>
    //     },

    //     // {
    //     //     key: "ticketid",
    //     //     text: "Ticket ID",
    //     //     className: "w_250 text-center",
    //     //     align: "center",
    //     //     width: 250,
    //     //     sortable: true,
    //     //     cell: rec => <div>43g345dfghjfjhg</div>
    //     // },
    //     {
    //         key: "status",
    //         text: "Ticket Status",
    //         className: "w_150 text-center",
    //         align: "center",
    //         width: 150,
    //         sortable: true,
    //         cell: rec =>
    //             <div>{FirstCaps(rec?.ticketStatus)}</div>
    //     },

    //     {
    //         key: "subject",
    //         text: "Subject",
    //         className: "w_200 text-center",
    //         align: "center",
    //         width: 200,
    //         sortable: true,
    //         cell: rec => <div>{rec?.Subject}</div>
    //     },
    // ]



    useEffect(() => {
        let cookie = ("; " + document.cookie)
            .split(`; ${config.cookiename}=`)
            .pop()
            .split(";")[0];
        if (cookie) {
            GetUserProfile(cookie);
        }
        else {
            navigate('/')
        }
    }, [])

    const GetUserProfile = async(cookie) => {
        if(!DisableStatus){
            SetDiableStatus(true);
            let resp = await GetuserData({ data: cookie, kyc: false })
            if(resp?.status){
            }
            else{
                navigate('/');
            }
            SetDiableStatus(false);
        }
    }

    useEffect(()=>{
        if (userdata?.payload) {
            GetSupportTicket();
        }
    },[userdata?.payload])

    const GetSupportTicket = async() => {
        try{
            let resp = await SupportTicketAction({ action: "get", UserId: userdata?.payload?._id })
            console.log('SupportTicketAction_resp',resp)
            SetSupportTicketList(resp?.data?resp?.data:[]);
        }
        catch(err){
            console.log('GetSupportTicket_error',err)
        }
    }

    const handleUploadAttachment = () => {
        attachmentRef.current.click()
    }

    const OnChange = (e) => {
        SetErrors({});
        let id = e?.target?.id;
        let value = e?.target?.value;
        SetFormData({...formdata,...{[id]:value}});
    }

    const HandleFile = (e) => {
        SetErrors({});
        let file = e?.target?.files?.[0];
        let id = e?.target?.id;
        if(file){
            setAttachmentName(file?.name);
            if(file?.type?.includes('image')||file?.type?.includes('video')||file?.type?.includes('pdf')){
                SetFormData({
                    ...formdata,
                    ...{
                        [id]: file
                    }
                })
            }
            else{
                toast.error("Upload Files that is pdf or image or video")
            }
        }
    }

    const Validate = () => {
        let errors = {};
        if(isEmpty(formdata?.Subject)){
            errors.Subject = "Enter Subject";
        }
        if(isEmpty(formdata?.Message)){
            errors.Message = "Enter Message";
        }
        return errors
    }

    const Submit = async () => {
        SetDisable(true);
        let error = Validate();
        if(isEmpty(error)){
            let resp = await SupportTicketAction({ 
                Subject: formdata?.Subject, 
                Attachment: formdata?.Attachment, 
                Message: formdata?.Message,
                UserId: userdata?.payload?._id,
                action: 'save',
            });
            console.log('SupportTicketAction_resp',resp);
            if(resp?.status){
                toast.success("Report Raised Successfully");
                SetErrors({});
                SetFormData(initform);
                GetSupportTicket();
                setAttachmentName("Click To Choose");
            }
            else{
                toast.error(resp?.msg?resp?.msg:"Try-Again");
            }
        }
        else{
            toast.error("Fix all Validations")
            SetErrors(error);
        }
        SetDisable(false);
    }

    return (
        <div>
            <Header />

            <section className='custom_section'>
                <div className='container py-4 py-md-5'>
                    <div>


                        <div className='row justify-content-center'>
                            <div className='col-12 col-sm-11 col-md-9 col-lg-8'>
                                <h2 className='color-brand-1 mb-4'>Support Ticket</h2>
                                <div className='row mx-auto'>
                                    <div className='col-12 col-md-12'>
                                        <div>
                                            <label className='fw-bold mb-2 profile_label'>Subject</label>
                                            <div className="form-group">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="name"
                                                    placeholder="Enter Subject"
                                                    id='Subject'
                                                    onChange={(e)=>OnChange(e)}
                                                    value={formdata?.Subject}
                                                />
                                                {
                                                    Errors?.Subject 
                                                    ?
                                                    <span className="error-msg">{Errors?.Subject}</span>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-12 mt-3'>
                                        <div>
                                            <label className='fw-bold mb-2 profile_label'>Message</label>
                                            <div className="form-group ">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="name"
                                                    placeholder="Enter Message"
                                                    id='Message'
                                                    onChange={(e)=>OnChange(e)}
                                                    value={formdata?.Message}
                                                />
                                                {
                                                    Errors?.Message 
                                                    ?
                                                    <span className="error-msg">{Errors?.Message}</span>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row mx-auto mt-3'>
                                    <div className='col-12 col-md-12'>
                                        <div>
                                            <label className='fw-bold mb-2 profile_label'>Attachment
                                                <span className='proile_label_span'> (Image should allowed only pdf/docx/jpg/png)</span>
                                            </label>

                                            <div className='file_name_wrapper' onClick={handleUploadAttachment}>
                                                {attachmentName}
                                            </div>

                                            <div className="form-group  d-none">
                                                <input
                                                    className="form-control"
                                                    type="file"
                                                    ref={attachmentRef}
                                                    name="name"
                                                    placeholder="e.g.Redeemable"
                                                    onChange={(e) => { HandleFile(e) }}
                                                    id='Attachment'
                                                />

                                                {/* <span className="error-msg">error</span> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-12 mt-3 d-flex align-items-end'>
                                        <button className='btn btn-brand-lg btn-full font-md-bold' style={{ maxWidth: "130px" }} onClick={()=>Submit()} disabled={Disable}>Submit</button>
                                    </div>
                                </div>
                                <div className="card_table mt-5">
                                    <ReactDatatable
                                        data={SupportTicketList}
                                        columns={columns}
                                        customStyles={customStyles}
                                        pagination
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Subscriber />
            <Footer />
        </div>
    )
}

export default SupportTicket